const Joi = require("joi");

const relationShipSchema = (data) => {
  const schema = Joi.object({
    AterModifiedRelationShip: Joi.string()
      .trim()
      .empty("") // Treat empty strings as invalid
      .required()
      .messages({
        "any.required": "Please enter Relationship.",
        "string.empty": "Please enter Relationship.", // Ensures the message is shown for empty strings
      }),
  }).unknown(true); // Allows additional fields in the object

  return schema.validate(data, {
    abortEarly: false, // Ensures all validation errors are returned
  });
};

module.exports = relationShipSchema;
